import { cva as cvaBase, VariantProps } from 'class-variance-authority'

export const cva = cvaBase

export { type VariantProps }
